import { useState } from 'react'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'
import { useInfiniteQuery } from '@tanstack/react-query'

export const useFetchPaymentsList = (userPhone: string) => {
  const [params, setParams] = useState({})

  let list = []
  let lastPage

  const query = useInfiniteQuery({
    queryKey: ['userPaymentsList', params],
    queryFn: ({ pageParam }) => {
      return api.payments.fetchPaymentsList({
        payerPhone: userPhone,
        ...params,
        page: pageParam,
        size: 20,
      })
    },
    initialPageParam: 0,
    getNextPageParam: ({ page }) => page + 1,
    enabled: !!userPhone,
  })

  if (query.isError) {
    toaster.create({
      type: 'error',
      title: 'Произошла ошибка при загрузки платежей',
      description: query.error?.message,
    })
  }

  if (query.data?.pages) {
    const content = query.data.pages.reduce((acc, item) => [...acc, ...item.payments], [])
    list = content?.length ? content : []
    lastPage = query.data.pages[query.data.pages.length - 1]
  }

  return {
    fetch: setParams,
    list,
    hasMore: lastPage?.page !== lastPage?.totalPages,
    ...query,
  }
}
